<template lang="pug">
  v-container
    v-form(v-model="form")
      v-row
        v-col
          v-text-field(
            v-model.number="dataState.data.maxDailyViews"
            type="number"
            filled
            label="Nombre soutien max quotidien par utilisateur"
            :rules="[value => !!value || `Champ requis.`, value => (value >= 1) || `Valeur inférieur à 1`]")
</template>

<script>
import { page } from '@iez/core'
import { reactive, toRefs } from '@vue/composition-api'
import fromDataState from '@iez/lib/from-data-state'
import data from '@iez/lib/data/'
import router from '@iez/core/router/'

const route = {
  name: `ManageDailyMaxViewsCount`,
  path: `/manage-daily-max-views-count/`
}

export default {
  ...route,

  setup () {
    page.topBar.set({
      title: `Gestion du nb de soutien max / user`
    })

    const configuration = data.get({
      root: `configurations`,
      one: true,
      fields: [
        `id`,
        `maxDailyViews`
      ],
      request: {
        order_by: {
          createdAt: `desc`
        }
      }
    })

    const state = reactive({
      form: false,
      dataState: fromDataState({
        getId: () => configuration.value?.id,
        props: {
          maxDailyViews: {
            get: () => configuration.value?.maxDailyViews
          }
        }
      })
    })

    page.bottomAction.set(
      () => state.dataState?.hasChanged && state.form
        ? {
          action: {
            label: `Enregistrer`,
            onClick: async () => {
              const _set = await state.dataState.smartPatch()
              await data.update({
                root: `configurations`,
                id: configuration.value?.id,
                _set,
                fields: [
                  `id`,
                  `maxDailyViews`
                ]
              })
              page.bottomSnackbar.set({
                content: `Modifié !`,
                afterEnter: true
              })
              router.back()
            }
          }
        } : null
    )

    return {
      ...toRefs(state),
      configuration
    }
  }
}
</script>
